<template lang="pug">
  //- set position class in parent (.fixed, ...)
  .z-60.w-full.h-full.inset-0(:class="[bg]")
    slot
    //- close button
    .overlay__close-btn.fixed.md-absolute.z-20.top-0.right-0.w-full.flex.justify-center.pt-10.md-pt-12.md-pr-30.md-w-auto.md-block
      button.flex.items-center.justify-center.h-40.w-40.md-bg-transp.border.border-gray-300.rounded-full.md-border-none.focus-border-blue.focus-text-blue(@click.stop="$emit('close')", aria-label="Close", :class="[bg]")
        svg-x(style="width:1.5rem;height:1.5rem")
</template>

<script>
import svgX from '@/components/Icons/SVG-X'
export default {
  name: 'Overlay',
  components: { svgX },
  props: {
    bg: { type: String, default: 'bg-white' }
  }
}
</script>

<style>
</style>
